// base
import { createSlice } from '@reduxjs/toolkit';

// actions
import { UI_SLICE_NAME } from '../actions/ui.action';

const initialState = {
  pageLoading: false,
  calledActions: [],
  isCollapsed: true,
  activeTab: 0
};

export const uiSlice = createSlice({
  name: UI_SLICE_NAME,
  initialState,
  reducers: {
    pageLoaderAction: (state, action) => {
      const { actionType } = action.payload;

      if (/pending/gi.test(actionType)) {
        state.calledActions = state.calledActions.concat(actionType.replace(/pending/gi, ''));
      }

      if (/fulfilled|rejected/gi.test(actionType)) {
        state.calledActions = state.calledActions.filter(
          (value) => value !== actionType.replace(/fulfilled|rejected/gi, '')
        );
      }

      state.pageLoading = state.calledActions.length ? true : false;
      state.actionType = action.payload.actionType;
    },
    collapsedAction: (state, action) => {
      state.isCollapsed = action.payload;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    }
  }
});

export const ui = uiSlice.name;
export const uiReducer = uiSlice.reducer;
export const uiActions = uiSlice.actions;
export default uiSlice.reducer;
